var _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129.4 129.4",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "notification_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M104.6 91.3V55.1a41.6 41.6 0 00-32-40.5v-4.3a10.2 10.2 0 00-7.7-10 10 10 0 00-12.3 9.8v4.5a41.6 41.6 0 00-32 40.5v36.2l-13 13.1v6.5h110v-6.5zm-53.8 25.5a12.2 12.2 0 1024.4 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notification_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11.4-18.8h149v166.58h-149z",
    fill: "currentColor"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTI5LjQgMTI5LjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJtMTA0LjYgOTEuM3YtMzYuMmE0MS42IDQxLjYgMCAwIDAgLTMyLTQwLjV2LTQuM2ExMC4yIDEwLjIgMCAwIDAgLTcuNy0xMCAxMCAxMCAwIDAgMCAtMTIuMyA5Ljh2NC41YTQxLjYgNDEuNiAwIDAgMCAtMzIgNDAuNXYzNi4ybC0xMyAxMy4xdjYuNWgxMTB2LTYuNXptLTUzLjggMjUuNWExMi4yIDEyLjIgMCAxIDAgMjQuNCAweiIvPjwvY2xpcFBhdGg+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBkPSJtLTExLjQtMTguOGgxNDl2MTY2LjU4aC0xNDl6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L2c+PC9zdmc+Cg==";
export { SvgNotification as ReactComponent };